<div class="products-ideal" id="products-ideal">

    <app-header class="shopping--active"></app-header>
    
    <div class="page">
        <span class="wave-decoration"></span>
        <div class="box-title">
            <div class="container">
                <h1 class="title-one">{{ textTitle }}</h1>
                <p class="title-description">Tenemos diferentes opciones para ti.</p>

            </div>
        </div>
        <div class="container p-none">
            <h2 class="title-two pl-base"><span class="icon">1</span>Selecciona el plan</h2>
            <p class="secondary-description d-none d-lg-block ml-huge width-40 text-small">Elige uno de nuestros planes de publicación y promociona tus proyectos lo antes posible.</p>
            <p class="secondary-description d-none d-lg-block ml-huge width-40 text-small">¡Empieza a disfrutar los beneficios de nuestros productos!</p>
            <div class="ideal-box">
                <app-carousel-card [dataPlan]='plans' [Parents]='listParent'></app-carousel-card>
            </div>
        </div>
        <app-contact-data-sticky-bar *ngIf="!(clientType === '3' || clientType === '4' || typeUser !== '' || plans.length === 0)"
            [store]="clientType" [titleSticky]="titleSticky"></app-contact-data-sticky-bar>
    </div>
    
    <lib-cc-footer [ccEnvironment]="ccEnvironment"></lib-cc-footer>
</div>